import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import "../styles/screens/third.css";

const IITNEETSection = () => {
  const [isVisible, setIsVisible] = useState(Array(4).fill(false));

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight;
      const sectionElement = document.getElementById('iit-neet-section');
      
      if (sectionElement) {
        const cards = sectionElement.querySelectorAll('.exam-card');
        
        cards.forEach((card, index) => {
          const cardPosition = card.offsetTop + sectionElement.offsetTop;
          
          if (scrollPosition > cardPosition + 100) {
            setIsVisible(prev => {
              const newState = [...prev];
              newState[index] = true;
              return newState;
            });
          }
        });
      }
    };

    window.addEventListener('scroll', handleScroll);
    // Trigger once on load
    setTimeout(handleScroll, 100);
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Exam information
  const examInfos = [
    {
      id: 1,
      title: "IIT-JEE Mains",
      description: "First stage of IIT-JEE for admission to NITs, IIITs, and GFTIs. Tests Physics, Chemistry, and Mathematics knowledge.",
      image: "https://varthana.com/student/wp-content/uploads/2024/01/Blog-Picture-4-09-01-2024-02.jpg",
      color: "#FF5722",
      path: "/jee-mains",
    },
    {
      id: 2,
      title: "IIT-JEE Advanced",
      description: "Second stage entrance exam for admission to the prestigious Indian Institutes of Technology (IITs).",
      image: "https://thehillstimes.in/wp-content/uploads/2024/06/IIT-JEE-advanced.jpg",
      color: "#2196F3",
      path: "/jee-advanced",
    },
    {
      id: 3,
      title: "NEET UG",
      description: "National Eligibility cum Entrance Test for undergraduate medical education in India.",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSrapIwT4r9KXdj0W4vTbkivCsPcn6DPLi0pqKemG__OkzXlUgfdGBx-M1fNB3m_iUt9-Y&usqp=CAU",
      color: "#4CAF50",
      path: "/neet-ug",
    },
    {
      id: 4,
      title: "NEET PG",
      description: "Entrance exam for postgraduate medical courses and specializations in India.",
      image: "https://api.educationpost.in/s3-images/1711353011232-174070-neet-pg-1.jpg",
      color: "#9C27B0",
      path: "/neet-pg",
    }
  ];

  return (
    <section id="iit-neet-section" className="py-5 my-5">
      <Container fluid className="py-4 px-3 px-md-4">
        <div className="text-center mb-5">
          <div 
            className="d-inline-block px-4 py-2 mb-3 rounded-pill"
            style={{ 
              backgroundColor: '#f0f8ff', 
              color: '#0056b3',
              fontSize: '1.2rem',
              fontWeight: '600'
            }}
          >
            Top Engineering & Medical Exams
          </div>
          <h2 className="mb-3 fw-bold section-title">Prepare for IIT-JEE & NEET</h2>
          <p className="text-muted section-subtitle" style={{ maxWidth: '700px', margin: '0 auto', fontSize: '1rem' }}>
            Comprehensive preparation materials and expert guidance for India's most competitive entrance exams
          </p>
        </div>
        
        <Row className="g-4 justify-content-center">
          {examInfos.map((exam, index) => (
            <Col xs={6} sm={6} md={6} lg={3} key={exam.id}>
              <Card 
                className={`h-100 shadow-sm exam-card ${isVisible[index] ? 'visible' : ''}`}
                style={{ 
                  borderRadius: '12px',
                  overflow: 'hidden',
                  border: 'none',
                  transform: isVisible[index] ? 'translateY(0)' : 'translateY(20px)',
                  opacity: isVisible[index] ? 1 : 0,
                  transition: 'all 0.4s ease',
                  transitionDelay: `${index * 0.15}s`
                }}
              >
                <div className="card-img-container" style={{ position: 'relative', height: '180px' }}>
                  <Card.Img 
                    variant="top" 
                    src={exam.image} 
                    alt={exam.title}
                    style={{ 
                      height: '100%',
                      width: '100%',
                      objectFit: 'cover',
                      objectPosition: exam.id === 3 ? 'center top' : 'center',
                    }} 
                  />
                  <div 
                    className="card-overlay"
                    style={{ 
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: `${exam.color}40`,
                    }}
                  ></div>
                  <div
                    className="exam-badge"
                    style={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      backgroundColor: exam.color,
                      color: 'white',
                      width: '32px',
                      height: '32px',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '16px',
                      fontWeight: 'bold',
                      boxShadow: '0 3px 6px rgba(0,0,0,0.16)'
                    }}
                  >
                    {index + 1}
                  </div>
                </div>
                
                <Card.Body className="p-3">
                  <Card.Title className="mb-2">
                    <span className="exam-title" style={{ 
                      fontSize: '1.15rem', 
                      fontWeight: '700',
                      color: '#333',
                      display: 'block'
                    }}>
                      {exam.title}
                    </span>
                  </Card.Title>
                  
                  <Card.Text style={{ 
                    fontSize: '0.85rem',
                    color: '#666',
                    marginBottom: '15px',
                    lineHeight: '1.5'
                  }}>
                    {exam.description}
                  </Card.Text>
                  
                  <div className="exam-features" style={{ marginBottom: '10px' }}>
                    <div className="feature d-flex align-items-center mb-2" style={{ fontSize: '0.85rem' }}>
                      <span className="feature-icon" style={{ 
                        marginRight: '8px',
                        fontSize: '1rem',
                        color: exam.color
                      }}>📊</span>
                      <span className="feature-text">Online Mock Tests</span>
                    </div>
                    <div className="feature d-flex align-items-center mb-2" style={{ fontSize: '0.85rem' }}>
                      <span className="feature-icon" style={{ 
                        marginRight: '8px',
                        fontSize: '1rem',
                        color: exam.color
                      }}>📚</span>
                      <span className="feature-text">Study Material</span>
                    </div>
                    <div className="feature d-flex align-items-center" style={{ fontSize: '0.85rem' }}>
                      <span className="feature-icon" style={{ 
                        marginRight: '8px',
                        fontSize: '1rem',
                        color: exam.color
                      }}>👨‍🏫</span>
                      <span className="feature-text">Expert Faculty</span>
                    </div>
                  </div>
                </Card.Body>
                
                <Card.Footer 
                  style={{ 
                    backgroundColor: 'white',
                    borderTop: '1px solid #f0f0f0',
                    padding: '12px 16px'
                  }}
                  className="d-flex justify-content-between align-items-center"
                >
                  <span style={{ 
                    color: exam.color,
                    fontSize: '0.8rem',
                    fontWeight: '500'
                  }}>
                    <strong>Trained By</strong> Experts
                  </span>
                  
                  <Link 
                    to={exam.path}
                    className="exam-btn"
                    style={{
                      backgroundColor: exam.color,
                      color: 'white',
                      padding: '6px 14px',
                      borderRadius: '6px',
                      fontSize: '0.8rem',
                      fontWeight: '600',
                      textDecoration: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = 'none';
                    }}
                  >
                    Explore <span className="arrow-icon" style={{ marginLeft: '5px' }}>→</span>
                  </Link>
                </Card.Footer>
              </Card>
            </Col>
          ))}
        </Row>
        
        <div className="mt-5 text-center">
          <p className="mb-0" style={{ fontSize: '0.9rem', maxWidth: '900px', margin: '0 auto' }}>
            <strong className="text-danger fw-bold">Note:- </strong>  
            IIT-JEE (Mains & Advanced) coaching is conducted by IIT alumni, ensuring top-tier guidance, while the NEET (UG & PG) program is led by medical experts. Additionally, live career guidance sessions are provided by AIIMS professionals and other distinguished doctors to help students navigate their medical careers effectively.
          </p>
        </div>
      </Container>
    </section>
  );
};

export default IITNEETSection;